// extracted by mini-css-extract-plugin
export var brand = "_5e-9";
export var compact = "_5e-6";
export var extraSmall = "_5e-7";
export var icon = "_5e-0";
export var large = "_5e-4";
export var light = "_5e-1";
export var medium = "_5e-5";
export var outline = "_5e-b";
export var primaryDark = "_5e-a";
export var primaryLight = "_5e-8";
export var primaryModern = "_5e-c";
export var success = "_5e-2";
export var successSolid = "_5e-3";